module.exports = __webpack_public_path__ + "static/media/food-health-plate.4a53762a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/header/assets/food-health-plate.jpg
// module id = 1073
// module chunks = 0